import accounting from 'accounting'

export default function formatCurrency(amount, currency, show_iso_code = false) {
  if (currency) {
    let { iso_code,
      symbol,
      symbol_first,
      decimal_mark,
      thousands_separator,
      decimal_places
    } = currency.format_data

    let  display_symbol = show_iso_code ? `${iso_code} ${symbol}` : symbol

    let format = {
      symbol: display_symbol,
      format: symbol_first ? '%s %v' : '%v %s',
      decimal: decimal_mark,
      thousand: thousands_separator,
      precision: decimal_places
    }

    return accounting.formatMoney(amount, format)
  } else {
    return accounting.formatMoney(amount)
  }
}



// WEBPACK FOOTER //
// ./src/helpers/formatCurrency.js